/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   7/16/21
 */

import {gql} from "urql";
import {ListResponse, VegaEvent} from "../../interfaces/Global";

export const CalendarEventsQuery = gql`
    query CalendarEvents(
        $createdBy: String, $createdByIn: [String!], $createdByNotIn: [String!],
        $creationDateGt: Date, $creationDateGte: Date, $creationDateLt: Date, $creationDateLte: Date,
        $modifiedBy: String, $modifiedByIn: [String!], $modifiedByNotIn: [String!],
        $modifiedDateGt: Date, $modifiedDateGte: Date, $modifiedDateLt: Date, $modifiedDateLte: Date,
        $employeeId: String, $employeeIdIn: [String!], $employeeIdNotIn: [String!],
        $typeId: String, $typeIdIn: [String!], $typeIdNotIn: [String!],
        $startDatetimeGt: Date, $startDatetimeGte: Date, $startDatetimeLt: Date, $startDatetimeLte: Date,,
        $endDatetimeGt: Date, $endDatetimeGte: Date, $endDatetimeLt: Date, $endDatetimeLte: Date,
        $confirmationDateGt: Date, $confirmationDateGte: Date, $confirmationDateLt: Date, $confirmationDateLte: Date,
        $isUnavailable: Boolean,
        $isConfirmed: Boolean,
        $descriptionLike: String,
        $managerId: String, $managerIdIn: [String!]
        $typeParentId: String, $typeParentIdIn: [String!]
        $capacityModifier: Float $capacityModifierGt: Float $capacityModifierGte: Float $capacityModifierLt: Float $capacityModifierLte: Float $capacityModifierNot: Float
        $limit: Int, $offset: Int, $orderBy: String) {
        calendarEvents(
            createdBy: $createdBy, createdByIn: $createdByIn, createdByNotIn: $createdByNotIn,
            creationDateGt: $creationDateGt, creationDateGte: $creationDateGte, creationDateLt: $creationDateLt, creationDateLte: $creationDateLte,
            modifiedDateGt: $modifiedDateGt, modifiedDateGte: $modifiedDateGte, modifiedDateLt: $modifiedDateLt, modifiedDateLte: $modifiedDateLte,
            modifiedBy: $modifiedBy, modifiedByIn: $modifiedByIn, modifiedByNotIn: $modifiedByNotIn,
            employeeId: $employeeId, employeeIdIn: $employeeIdIn, employeeIdNotIn: $employeeIdNotIn,
            typeId: $typeId, typeIdIn: $typeIdIn, typeIdNotIn: $typeIdNotIn,
            startDatetimeGt: $startDatetimeGt, startDatetimeGte: $startDatetimeGte, startDatetimeLt: $startDatetimeLt, startDatetimeLte: $startDatetimeLte,
            endDatetimeGt: $endDatetimeGt, endDatetimeGte: $endDatetimeGte, endDatetimeLt: $endDatetimeLt, endDatetimeLte: $endDatetimeLte,
            confirmationDateGt: $confirmationDateGt, confirmationDateGte: $confirmationDateGte, confirmationDateLt: $confirmationDateLt, confirmationDateLte: $confirmationDateLte,
            isUnavailable: $isUnavailable,
            isConfirmed: $isConfirmed,
            descriptionLike: $descriptionLike,
            managerId: $managerId, managerIdIn: $managerIdIn,
            typeParentId: $typeParentId, typeParentIdIn: $typeParentIdIn,
	        capacityModifier: $capacityModifier, capacityModifierGt: $capacityModifierGt, capacityModifierGte: $capacityModifierGte, capacityModifierLt: $capacityModifierLt, capacityModifierLte: $capacityModifierLte, capacityModifierNot: $capacityModifierNot
            limit: $limit, offset: $offset, orderBy: $orderBy) {
            total
            items {
                id
	            createdBy
                createdByEmployee {
	                id
	                displayName
                }
	            creationDate
	            modifiedBy
	            modifiedByEmployee {
		            id
		            displayName
	            }
	            modifiedDate
	            vstamp
	            employeeId
	            employee {
		            id
		            displayName
	            }
                typeId
	            startDatetime
	            endDatetime
	            isConfirmed
	            confirmationDate
	            confirmedBy
	            confirmedByEmployee {
		            id
		            displayName
	            }
	            description
	            capacityModifier
	            properties
            }
        }
    }
`;

export const SearchCalendarEventsQuery = gql`
    query SearchCalendarEvents(
        $createdBy: String, $createdByIn: [String!], $createdByNotIn: [String!],
        $creationDateGt: Date, $creationDateGte: Date, $creationDateLt: Date, $creationDateLte: Date,
        $modifiedBy: String, $modifiedByIn: [String!], $modifiedByNotIn: [String!],
        $modifiedDateGt: Date, $modifiedDateGte: Date, $modifiedDateLt: Date, $modifiedDateLte: Date,
        $employeeId: String, $employeeIdIn: [String!], $employeeIdNotIn: [String!],
        $typeId: String, $typeIdIn: [String!], $typeIdNotIn: [String!],
        $startDatetimeGt: Date, $startDatetimeGte: Date, $startDatetimeLt: Date, $startDatetimeLte: Date,,
        $endDatetimeGt: Date, $endDatetimeGte: Date, $endDatetimeLt: Date, $endDatetimeLte: Date,
        $confirmationDateGt: Date, $confirmationDateGte: Date, $confirmationDateLt: Date, $confirmationDateLte: Date,
        $isUnavailable: Boolean,
        $isConfirmed: Boolean,
        $descriptionLike: String,
	    $managerId: String, $managerIdIn: [String!]
	    $typeParentId: String, $typeParentIdIn: [String!]
        $capacityModifier: Float $capacityModifierGt: Float $capacityModifierGte: Float $capacityModifierLt: Float $capacityModifierLte: Float $capacityModifierNot: Float
        $limit: Int, $offset: Int, $orderBy: String) {
        calendarEvents(
            createdBy: $createdBy, createdByIn: $createdByIn, createdByNotIn: $createdByNotIn,
            creationDateGt: $creationDateGt, creationDateGte: $creationDateGte, creationDateLt: $creationDateLt, creationDateLte: $creationDateLte,
            modifiedDateGt: $modifiedDateGt, modifiedDateGte: $modifiedDateGte, modifiedDateLt: $modifiedDateLt, modifiedDateLte: $modifiedDateLte,
            modifiedBy: $modifiedBy, modifiedByIn: $modifiedByIn, modifiedByNotIn: $modifiedByNotIn,
            employeeId: $employeeId, employeeIdIn: $employeeIdIn, employeeIdNotIn: $employeeIdNotIn,
            typeId: $typeId, typeIdIn: $typeIdIn, typeIdNotIn: $typeIdNotIn,
            startDatetimeGt: $startDatetimeGt, startDatetimeGte: $startDatetimeGte, startDatetimeLt: $startDatetimeLt, startDatetimeLte: $startDatetimeLte,
            endDatetimeGt: $endDatetimeGt, endDatetimeGte: $endDatetimeGte, endDatetimeLt: $endDatetimeLt, endDatetimeLte: $endDatetimeLte,
            confirmationDateGt: $confirmationDateGt, confirmationDateGte: $confirmationDateGte, confirmationDateLt: $confirmationDateLt, confirmationDateLte: $confirmationDateLte,
            isUnavailable: $isUnavailable,
            isConfirmed: $isConfirmed,
            descriptionLike: $descriptionLike,
	        managerId: $managerId, managerIdIn: $managerIdIn,
	        typeParentId: $typeParentId, typeParentIdIn: $typeParentIdIn,
            capacityModifier: $capacityModifier, capacityModifierGt: $capacityModifierGt, capacityModifierGte: $capacityModifierGte, capacityModifierLt: $capacityModifierLt, capacityModifierLte: $capacityModifierLte, capacityModifierNot: $capacityModifierNot
            limit: $limit, offset: $offset, orderBy: $orderBy) {
            total
            items {
                id
                createdBy
                createdByEmployee {
                    id
                    displayName
                }
                creationDate
                modifiedBy
                modifiedByEmployee {
                    id
                    displayName
                }
                modifiedDate
                vstamp
                employeeId
                employee {
                    id
                    displayName
	                manager {
		                id
		                displayName
                    }
                }
                typeId
	            type {
		            id
		            name
		            isUnavailable
		            parentId
		            parent {
			            id
			            name
                    }
	            }
                startDatetime
                endDatetime
                isConfirmed
                confirmationDate
                confirmedBy
                confirmedByEmployee {
                    id
                    displayName
                }
                description
	            capacityModifier
	            properties
            }
        }
    }
`;

export interface CalendarEventsResponse {
	calendarEvents: ListResponse<VegaEvent>
}

export interface CalendarEventsQueryVars {
	createdBy?: string 
	createdByIn?: string[] 
	createdByNotIn?: string[]
	creationDateGt?: Date 
	creationDateGte?: Date 
	creationDateLt?: Date 
	creationDateLte?: Date
	modifiedBy?: string 
	modifiedByIn?: string[] 
	modifiedByNotIn?: string[]
	modifiedDateGt?: Date 
	modifiedDateGte?: Date 
	modifiedDateLt?: Date 
	modifiedDateLte?: Date
	employeeId?: string 
	employeeIdIn?: string[] 
	employeeIdNotIn?: string[]
	typeId?: string 
	typeIdIn?: string[] 
	typeIdNotIn?: string[]
	startDatetimeGt?: Date 
	startDatetimeGte?: Date 
	startDatetimeLt?: Date 
	startDatetimeLte?: Date
	endDatetimeGt?: Date 
	endDatetimeGte?: Date 
	endDatetimeLt?: Date 
	endDatetimeLte?: Date
	confirmationDateGt?: Date 
	confirmationDateGte?: Date 
	confirmationDateLt?: Date 
	confirmationDateLte?: Date
	isUnavailable?: boolean
	isConfirmed?: boolean
	descriptionLike?: string
	managerId?: string
	managerIdIn?: string[]
	typeParentId?: string
	typeParentIdIn?: string[]
	capacityModifier?: number
	capacityModifierGt?: number
	capacityModifierGte?: number
	capacityModifierLt?: number
	capacityModifierLte?: number
	capacityModifierNot?: number
	limit?: number
	offset?: number 
	orderBy?: string
}
